import React, { useEffect, useState, useRef } from "react";

const Debugger = ({setShowDebugger, showDebugger}) => {
  const [counter, setCounter] = useState(0);
  const lastIncrementTime = useRef(null);
  
  useEffect(() => {
    if (counter === 5) {
      const now = Date.now();
      if (lastIncrementTime.current && now - lastIncrementTime.current <= 2000) {
        setShowDebugger(!showDebugger);
      } 
      lastIncrementTime.current = null; // Resetear tiempo
      setCounter(0); // Resetear contador
    }
  }, [counter]);

  const handleClick = () => {
    if (counter === 0) {
      lastIncrementTime.current = Date.now(); // Guardar tiempo del primer click
    }
    setCounter(prev => prev + 1);
  };

  return (
    <div className="absolute right-0 w-20 h-20 z-40" onClick={handleClick}>
    </div>
  );
};

export default Debugger;
